<ng-container *ngIf="isVisible">
  <div class="mx-2 mt-2 pb-3">
    <div class="d-flex justify-content-between">
      <h3>User Preferences</h3>
      <button
        nf-icon-button="secondary"
        icon="close"
        class="btn-bare close"
        ngbTooltip="Close Session Catalog"
        (click)="closePanel.emit()"
      >
        Close User Preferences
      </button>
    </div>
    <div class="panel-section">
      <nf-form-control static compact for="compact-mode" label="Compact Mode">
        <nf-toggle
          elId="compact-mode"
          [formControl]="compactMode"
          states
        ></nf-toggle
      ></nf-form-control>

      <nf-form-control static compact for="focus-mode" label="Focus Mode">
        <nf-toggle
          elId="focus-mode"
          [formControl]="focusMode"
          states
        ></nf-toggle
      ></nf-form-control>

      <nf-form-control static compact for="grid-lines" label="Grid Lines">
        <nf-toggle
          elId="grid-lines"
          [formControl]="gridLines"
          states
        ></nf-toggle
      ></nf-form-control>
      <nf-form-control
        static
        compact
        for="bulk-sort-prompt"
        label="Allow Sorting in Bulk Dialogs"
      >
        <nf-toggle
          elId="bulk-sort-prompt"
          [formControl]="bulkSortPreference"
          states
        ></nf-toggle>
      </nf-form-control>
      <nf-form-control
        static
        compact
        for="hide-delete-prompt"
        label="Hide Delete Prompt"
      >
        <nf-toggle
          elId="hide-delete-prompt"
          [formControl]="deletePromptPreference"
          states
        ></nf-toggle>
      </nf-form-control>
      <nf-form-control
        static
        compact
        for="auto-refresh-account"
        label="Auto Refresh Account On Run"
      >
        <nf-toggle
          elId="auto-refresh-account"
          [formControl]="autoRefreshAccount"
          states
        ></nf-toggle>
      </nf-form-control>
      <nf-form-control
        static
        compact
        for="use-old-multi-row-grid-code"
        label="Switch back to old multi grid mode"
      >
        <nf-toggle
          elId="use-old-multi-row-grid-code"
          [formControl]="useOldMultiRowGridCode"
          states
        ></nf-toggle>
      </nf-form-control>

      <nf-form-control
        static
        compact
        for="force-close-session"
        label="Force Close Session"
      >
        <nf-toggle
          elId="force-close-session"
          [formControl]="forceCloseSessionPreference"
          states
        ></nf-toggle>
      </nf-form-control>
      <nf-form-control
        static
        compact
        for="save-modal-positions"
        label="Save Modal Positions"
      >
        <nf-toggle
          elId="save-modal-positions"
          [formControl]="saveModalPositions"
          states
        ></nf-toggle>
      </nf-form-control>
      <nf-form-control static compact label="UI Scale">
        <nf-radio-group [formControl]="uiScale">
          <nf-radio-button
            label="Auto"
            [value]="UiScale.Auto"
          ></nf-radio-button>
          <nf-radio-button
            label="Smaller"
            [value]="UiScale.Scaled"
          ></nf-radio-button>
          <nf-radio-button
            label="Normal"
            [value]="UiScale.Normal"
          ></nf-radio-button>
        </nf-radio-group>
      </nf-form-control>
      <ng-container *ngIf="developerOnly$ | async">
        <h3>Developer Only</h3>
        <nf-form-control
          static
          compact
          for="redux-devtools"
          label="Redux Devtools"
        >
          <nf-toggle
            elId="redux-devtools"
            [formControl]="reduxDevtools"
            states
          ></nf-toggle
        ></nf-form-control>
      </ng-container>
    </div>
  </div>
</ng-container>
